var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 38,
    height: 24,
    rx: 2.5,
    stroke: "#F4F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0497 9.8585C26.4187 10.5185 26.4667 11.369 26.2747 12.3538C25.7197 15.2083 23.8177 16.1938 21.3892 16.1938H21.0142C20.8705 16.194 20.7316 16.2455 20.6224 16.3389C20.5133 16.4324 20.441 16.5618 20.4187 16.7038L20.3887 16.8688L19.9162 19.8635L19.8922 19.991C19.8699 20.1329 19.7976 20.2622 19.6885 20.3555C19.5793 20.4489 19.4404 20.5002 19.2967 20.5003H16.7895C16.7372 20.5002 16.6855 20.4889 16.6379 20.467C16.5904 20.4451 16.5482 20.4132 16.5142 20.3734C16.4802 20.3336 16.4553 20.287 16.441 20.2366C16.4268 20.1863 16.4236 20.1334 16.4317 20.0818L16.563 19.25H17.7015L18.414 14.735H19.4527C22.9612 14.735 25.2652 13.0828 26.0497 9.8585ZM23.8297 6.041C24.4012 6.692 24.567 7.3985 24.3937 8.50475C24.3795 8.597 24.3637 8.68475 24.3472 8.77475C23.796 11.6045 22.0305 12.8593 19.1302 12.8593H17.7172C17.2447 12.8593 16.8367 13.1698 16.7017 13.6108L16.6912 13.6093L15.9937 18.0298H13.3402C13.3346 18.0297 13.3291 18.0285 13.3241 18.0261C13.319 18.0237 13.3146 18.0203 13.311 18.016C13.3074 18.0117 13.3048 18.0067 13.3034 18.0013C13.302 17.9959 13.3017 17.9902 13.3027 17.9848L15.2512 5.60225C15.2775 5.43451 15.3628 5.28166 15.4918 5.17124C15.6208 5.06083 15.7849 5.0001 15.9547 5H20.4367C22.074 5 23.2237 5.35175 23.829 6.041H23.8297Z",
    fill: "#253B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalcard);
export default __webpack_public_path__ + "static/media/paypalcard.f8f6acb8598ae563830d58c3e207fec9.svg";
export { ForwardRef as ReactComponent };